import { IPageExtendBehavior } from "./IPageExtendBehavior";

export interface IPageExtendBehaviorSpecifiable {
  pageExtendBehavior: IPageExtendBehavior;
}

export function instanceOfIPageExtendBehaviorSpecifiable(instance: any): instance is IPageExtendBehaviorSpecifiable {
  return instance
    && (instance.pageExtendBehavior !== undefined);
}
